// Convert an ISO-3166-1 alpha-2 country code to a regional-indicator emoji.
// e.g. "hk" → 🇭🇰, "us" → 🇺🇸
export function flagEmoji(iso2: string | undefined | null): string | null {
  if (!iso2 || iso2.length !== 2) return null;
  const upper = iso2.toUpperCase();
  if (!/^[A-Z]{2}$/.test(upper)) return null;
  return String.fromCodePoint(
    0x1f1e6 - 65 + upper.charCodeAt(0),
    0x1f1e6 - 65 + upper.charCodeAt(1),
  );
}
